import {
  AnalyticsCards,
  AnalyticsChart,
  AnalyticsDataTable,
  AnalyticsDataTableWrapper,
  ApiPagination,
} from "@/components";
import React, { useEffect, useMemo, useState } from "react";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { fetchCustomPaginatedOrdersQueryOptions } from "@/queryOptions/orders/fetchCustomPaginatedOrders";
import data from "@/utils/AnalyticsDataTable.json";
import { $setState } from "lexical";
import { fetchAllOrdersQueryOptions } from "@/queryOptions/orders/fetchAllOrders";
import { LoaderCircle } from "lucide-react";
const SalesAnalytics = () => {
  const [isSearchActive, setIsSearchActive] = useState(false);

  const [date, setDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 30)).toISOString()
  );
  const {
    data: queryResult,
    isLoading: productsLoading,
    isSuccess,
  } = useQuery(
    fetchAllOrdersQueryOptions(
      { created_at: { gt: date } },
      {
        staleTime: 1000 * 60 * 5,
        enabled: !isSearchActive,
      }
    )
  );

  if (queryResult) {
    console.log("Query result:", queryResult);
  }
  if (productsLoading) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        <LoaderCircle className="w-6 h-6 animate-spin mr-4 "></LoaderCircle>
        Fetching Sales analytics. This won't take long!
      </div>
    );
  }
  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
      <AnalyticsCards data={queryResult ?? []} />
      <div className="px-4 lg:px-6">
        <AnalyticsChart data={queryResult ?? []} />
      </div>
      <AnalyticsDataTableWrapper />
    </div>
  );
};

export default SalesAnalytics;
